import "./organisation-owner-root.component.scss";

export default {
  template: require('./organisation-owner-root.component.html'),
  controller: function ($scope, $timeout, $location, $t, $auth, $gl, $alert,
                        OrganisationOwnerContactUsApi, vuiModals, $routeParams, vuiOrganisationManagerPermissions) {
    'ngInject';

    const self = $scope.$ctrl;

    self.auth = $auth;
    self.params = $routeParams;
    self.homePath = '/organisation/' + self.params.orgId + '/service-bookings'

    vuiOrganisationManagerPermissions.hasPermission('VIEWER', permit => {
      if (!permit) {
        $location.url('/organisations')
      }
    })

    self.submitContactUs = message => {
      $gl.show();
      OrganisationOwnerContactUsApi.send({orgId: $routeParams.orgId}, {body: message},
        response => {
          const successMessage = $t('shared.modals.contact_us.sending_success_message');
          vuiModals.info(successMessage);
          $gl.hide();
        },
        error => {
          $gl.hide();
          $alert.processError(error, $t('public.about.contact_us.send_message_error_message'));
        })
    }

    const checkUrl = () => {
      const path = '/organisation/' + $routeParams.orgId;
      if (path === $location.path()) {
        $location.url(path + '/service-bookings');
      }
    }

    checkUrl();

  }
};
